module.exports = __webpack_public_path__ + "img/heavy_armor_2.5c3afc1b.png";